<template>
  <iColumn gap="extraSmall" width="fill">
    <iText font-weight="strong">
      {{ entity?.authorName || 'Author' }}
    </iText>
    <iText>
      {{ entity?.message || entity?.text || 'This is a sample comment message.' }}
    </iText>
  </iColumn>
</template>

<script>
// `%/components/community/chatrooms/comments/...` and
// `%/apps/conversations/stores/...` live outside the editor directory
// tree. Studio canvas preview just shows the author + message text
// off the example entity.
import { StoryCommentElementMixin } from "%/dynamic-component-editor/standard-components/story-comment/story-comment-element-mixin";
import { ActionElementMixin } from "%/dynamic-component-editor/standard-elements/action-element/action-element-mixin";

export default {
  name: "StoryCommentMessage",
  elementPanelSettings: {
    displayName: "Message",
    displayIcon: "paragraph",
    elementGroup: "Story Comments",
    elementType: "element",
  },
  mixins: [StoryCommentElementMixin, ActionElementMixin],
};
</script>
